<template>
    <div class="row">
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        
        <div class="col-3">

            <div class="my-3">
                <h4>{{ formVersion ? formVersion.form_title : '' }}</h4>
            </div>
            
            <div class="d-flex gap-4 my-3">
                <!-- <b-button
                    variant="success"
                    @click="loadFormioThings"
                >Load Builder</b-button> -->

                <b-button
                    variant="primary"
                    @click="saveSchema"
                >Save New Schema</b-button>

                <b-button
                    variant="primary"
                    @click="resetSchema"
                >Reset Schema</b-button>

                <b-form-select
                    :value="formDisplayType"
                    :options="formDisplayTypeOptions"
                    @change="handleFormDisplayTypeChange"
                    class="w-auto"
                ></b-form-select>

            </div>

            <div>
                <h5>Form Version Details:</h5>
                <pre>{{ formVersionWithoutSchema }}</pre>
            </div>

            <div class="my-3">
                <h5>Schema:</h5>
                <pre>{{ currentBuilderSchema }}</pre>
            </div>

        </div>

        <div class="col-9">

            <div class="row my-4">
                <div class="col-12">
                    <div ref="formio-builder" class="w-100"></div>
                </div>
            </div>
            
            <div class="row my-4">
                <div class="col-4">
                    <h6>Preview Form Data</h6>
                    <pre>{{ previewFormData ? previewFormData : {} }}</pre>
                </div>
                <div class="col-8">
                    <div class="w-100 my-4 d-flex align-items-center justify-content-center">
                        <div class="w-100 preview-wrapper max-width-800 p-3 border rounded-lg bg-gray-100 shadow-sm">
                            <div ref="formio-preview" class="w-100 spl-formio-form spl-workflow-form"></div>
                        </div>
                    </div>
                </div>
            </div>

        </div>        
    
    </div>
</template>

<script>
import { errorHandling } from '../../js/custom-vue-mixins';
import { suppliosApi } from '../../js/api-service';
import cloneDeep from 'lodash/cloneDeep';
import omit from 'lodash/omit';

/* const defaultFormioSchemaForm = {
    display: 'form',

} */

const defaultWizardSchema = {
    display: 'wizard',
    components: [
        {
            "title": "Page 1",
            "label": "Page 1",
            "type": "panel",
            "key": "page1",
            "input": false,
            "tableView": false,
            "components": []
        },
    ],
};
const defaultFormSchema = {
    display: 'form',
    components: [],
};

export default {
    name: 'WorkflowFormVersionBuilder',
    components: {},
    mixins: [
        errorHandling,
    ],
    props: {
        formVersionId: {
            type: String,
            required: true,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loading: false,
            // OUR DATA
            formVersion: null,  // we'll stash from API
            formVersionWithoutSchema: null,  // pull off schema to just display everything else
            originalSchema: null,  // stash here whatever we got from last saved
            currentSchema: null,  // set this when you first load the builder, then anytime you update
            currentBuilderSchema: null,  // used to be computed, now explicitly updating - we save this one when done editing
            previewFormData: null,  // submission data for preview form - explicitly updating
            // GENERAL FORMIO STUFF 
            globalFormio: null,  // from window.Formio - we'll stash it here
            // BUILDER 
            formDisplayType: 'form',  // 'form', 'wizard', etc.
            formDisplayTypeOptions: ['form', 'wizard'],
            builderElement: null,
            builderOptions: {
                noDefaultSubmitButton: true,
                formConfig: {},  // the config of the form object being created
                builder: {
                    custom: {
                        title: 'Pre-Defined Fields',
                        weight: 10,
                        components: {
                            causeTable: {
                                title: 'Cause Table',
                                key: 'causeTable',
                                icon: 'terminal',
                                schema: {
                                    label: 'Cause Table',
                                    type: 'causetable',
                                    key: 'causeTable',
                                    input: true,
                                },
                            },
                            firstName: {
                                title: 'First Name',
                                key: 'firstName',
                                icon: 'terminal',
                                schema: {
                                    label: 'First Name',
                                    type: 'textfield',
                                    key: 'firstName',
                                    input: true
                                }
                            },
                            lastName: {
                                title: 'Last Name',
                                key: 'lastName',
                                icon: 'terminal',
                                schema: {
                                label: 'Last Name',
                                type: 'textfield',
                                key: 'lastName',
                                input: true
                                }
                            },
                            email: {
                                title: 'Email',
                                key: 'email',
                                icon: 'at',
                                schema: {
                                    label: 'Email',
                                    type: 'email',
                                    key: 'email',
                                    input: true
                                }
                            },
                            phoneNumber: {
                                title: 'Mobile Phone',
                                key: 'mobilePhone',
                                icon: 'phone-square',
                                schema: {
                                    label: 'Mobile Phone',
                                    type: 'phoneNumber',
                                    key: 'mobilePhone',
                                    input: true
                                }
                            },
                            pictures: {
                                title: 'Pictures',
                                key: 'pictures',
                                icon: 'phone-square',
                                schema: {
                                    label: "Pictures",
                                    tableView: false,
                                    storage: "url",
                                    image: true,
                                    webcam: false,
                                    fileTypes: [
                                        {label: "", value: ""},
                                    ],
                                    fileMaxSize: "10MB",
                                    multiple: true,
                                    key: "pictures1",
                                    type: "file",
                                    url: "/quality/api/dwf_task_file_uploader/",
                                    imageSize: "300",
                                    input: true,
                                }
                            },
                            pageInstructions: {
                                title: 'Page Instructions',
                                key: 'pageInstructions',
                                icon: 'file',
                                schema: {
                                    title: "Instructions",
                                    buttonSettings: {
                                        previous: false,
                                        cancel: false,
                                        next: false
                                    },
                                    scrollToTop: false,
                                    customClass: "spl-formio-page-instructions",
                                    collapsible: false,
                                    key: "pageInstructions",
                                    type: "panel",
                                    label: "Panel",
                                    input: false,
                                    tableView: false,
                                    breadcrumbClickable: false,
                                    allowPrevious: false,
                                    components: [],
                                },
                            },
                        }
                    }
                }
            },  // for user-facing builders, you'll customize this a lot
            builder: null,  // the builder, not the builder.instance - must get things through here, because when you change display types (form to wizard) I think it destroys the old builder.instance, so keeping reference to it is not useful
            builderSchema: null,  // get it from builder.instance.schema
            isBuilderValid: null,  // will be boolean when we check
            // PREVIEW FORM - we have to re-create it each time we change builder -- that's what formio does in their examples too
            formElement: null,
            formOptions: {},
            formInst: null,
        }
    },
    computed: {
        /* currentBuilderSchema() {  // explicitly updating instead - in loadPreview / onBuilderChange
            return this.builder?.instance?.schema;
        }, */
        /* previewFormData() { // same... updating explicitly instead 
            return this.formInst?.submission?.data;
        }, */
    },
    created() {
    },
    mounted() {
        this.getFormVersion();
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        async getFormVersion() {
            // get the data about the form version from Supplios backend before we launch the builder
            this.loading = true;
            try {
                const { data } = await suppliosApi.workflowFormVersion.get_admin_builder(this.formVersionId);
                this.originalSchema = cloneDeep(data.raw_schema);
                this.currentSchema = cloneDeep(data.raw_schema);  // yes... same as original, but we'll be mutating this one, just being safe
                if (!this.currentSchema.display) {
                    this.currentSchema.display = 'form';  // set a default in case we didn't have it
                } else {
                    // but if it was already set, set that locally in our select box
                    this.formDisplayType = this.currentSchema.display;
                }
                this.formVersion = Object.assign({}, data);
                this.formVersionWithoutSchema = omit(cloneDeep(data), ['raw_schema']);
                // NOW LOAD THE FORM BUILDER
                this.loadFormioThings();
            } catch (err) {
                this.apiErrorHandler(err);
            }
            this.loading = false;
        },
        async loadFormioThings() {
            if (window.Formio) {
                console.log('We HAVE Formio');
                this.globalFormio = window.Formio;  // use global here
            } else {
                console.log('NO FORMIO');
            }
            // get elements
            this.builderElement = this.$refs['formio-builder'];
            this.formElement = this.$refs['formio-preview'];
            await this.loadBuilder();
            // await this.loadPreview();
        },
        async loadBuilder() {
            // load the builder AND the preview -- builder first - things should be ready 
            //const builderElement = this.$refs['formio-builder'];
            if (!this.builderElement) {
                console.log('could not get the formio-builder ref!');
                return;
            }
            console.log('got the formio-builder ref, will render the builder');
            const formSchema = cloneDeep(this.currentSchema);  // we're mutating this... will it work like this?  or clone?
            // seems you can use Formio.builder() without chaining .ready -- OR Formio.FormBuilder() with chaining .ready after it -- both return the builder.instance it seems?
            this.builder = await new this.globalFormio.FormBuilder(this.builderElement, formSchema, this.builderOptions);
            console.log('Here is the builder (this.builder):', this.builder);
            await this.builder.instance.ready;
            this.onBuilderReady();
            this.loadPreview();
        },
        onBuilderReady() {
            // splitting this out from making the builder so it refreshes appropriately when changing display type, etc.
            // got this from the formio builder example
            this.builder.instance.on('change', (changed) => {
                console.log('BUILDER CHANGED!', changed);
                this.handleBuilderChange();
            });
        },
        /* onPreviewFormChange(changedData) {
            // call this when the PREVIEW form changes, we use this to update the preview form data
            console.log('onPreviewFormChange', changedData);
            this.previewFormData = cloneDeep(changedData);
        }, */
        async loadPreview() {
            //const formElement = this.$refs['formio-preview'];
            if (!this.formElement) {
                console.log('could not get the formio-preview ref!');
                return;
            }
            console.log('got the formio-preview ref, will render the form');
            //const formSchema = Object.assign({}, cloneDeep(this.schema));  // clone it to decouple... otherwise when you start typing in preview form, it mutates the schema  
            //const formSchema = JSON.parse(JSON.stringify(this.schema));
            // .createForm only works on the global Formio -- not on an instance of it, which we made to decouple from the builder - use .loadForm() instead
            // NEW - July 12 2022 - had problems with schema not updating when making changes... 
            // we'll try destroying the preview form first, before rebuilding it OR just setForm(newSchema) - to update the schema
            //console.log('in loadPreview - do we already have this.formInst?', Boolean(this.formInst), this.formInst);
            // if we don't have this.formInst yet, we'll create it -- otherwise we'll just update it using its setForm() method, pass in the new schema
            // this.builder.instance.form is the 'enhanced' JSON schema of the form -- this.builder.instance.schema is the 'minified' version of the schema, with extra stuff stripped away... but apprently is generated dynamically, so maybe not performant to use that
            // where is the original schema??? not sure...  seems undocumented so we won't use it
            
            const newSchema = cloneDeep((this.builder?.instance?.schema ?? {}));
            this.currentBuilderSchema = newSchema;  // this is what we save when done editing
            // const newSchema = cloneDeep(this.builder.instance.form);  // schema is the short version, form is the long version - we'll use schema, since that's what we'll be saving
            if (this.formInst) {
                /* console.log('updating existing preview form');
                await this.formInst.setForm(newSchema);  // returns a promise when its done
                // we'll also reset the form data 
                await this.formInst.setSubmission({data: {}}); */
                // TRY REBUILDING EVERYTHING
                console.log('DESTROY / RECREATE NEW PREVIEW FORM');
                this.formInst.destroy();
                //this.formInst = await this.globalFormio.createForm(this.formElement, this.builder.instance.form, this.formOptions);
                this.formInst = await this.globalFormio.createForm(this.formElement, newSchema, this.formOptions);
                // now after making the preview form instance, register change handler to update the preview data
                this.formInst.on('change', (changed) => {
                    //this.onPreviewFormChange(changed.data);  // changed has lots of stuff in it... we just want the new data 
                    this.previewFormData = cloneDeep(changed.data);
                });
            } else {
                // no form preview yet?  create it - originally we were doing this on every call of this function.... probably why we had memory problems over time....
                console.log('MAKING NEW PREVIEW FORM');
                //this.formInst = await this.globalFormio.createForm(this.formElement, this.builder.instance.form, this.formOptions);
                this.formInst = await this.globalFormio.createForm(this.formElement, newSchema, this.formOptions);
                // now after making the preview form instance, register change handler to update the preview data
                this.formInst.on('change', (changed) => {
                    //this.onPreviewFormChange(changed.data);  // changed has lots of stuff in it... we just want the new data 
                    this.previewFormData = cloneDeep(changed.data);
                });
            }
            // update the preview data -- make sure you await the update/create above
            // MAY NOT NEED IT??? JUST SHOW IN TEMPLATE?  this.previewFormData = this.formInst.submission.data;
            //this.formInst = await new this.globalFormio.Form(this.formElement, this.builderInst.form, {renderMode: 'html'});  // THIS WORKS FOR RENDERING FORM WITH NO INPUTS
            //console.log('built the form -- here is this.formInst:', this.formInst);
            // event listeners
            // listening for this 'change' is screwing up the schema for the builder!
            // perhaps the 'streams cross' somewhere in the formio eventing system.... 
            // anyways... we'll watch for changes to the form data some other way - computed?
            /* this.form.on('change', (changed) => {
                console.log('FORM PREVIEW CHANGED!', changed);
                const previewData = this.formInst.submission.data;
                this.previewData = Object.assign({}, previewData);
            }); */
        },
        handleBuilderChange() {
            console.log('updating schema...');
            //this.currentSchema = cloneDeep(this.builderInst.schema);
            this.loadPreview();
            this.checkBuilderValid();
        },
        async handleFormDisplayTypeChange(formDisplayType) {
            // will be 'form' or 'wizard' maybe pdf later?
            // must rebuild the builder from the start when we change this
            await this.builder.setDisplay(formDisplayType);
            this.onBuilderReady();  // make sure it gets its schema from the local value, in case we made changes!
        },
        checkBuilderValid() {  // maybe just use computed instead? maybe it won't watch deeply enough?
            console.log('checking if builder is valid...');
            this.isBuilderValid = !this.builder.instance.invalid;
        },
        async resetSchema() {
            let baseSchema;
            if (this.formDisplayType === 'form') {
                baseSchema = defaultFormSchema;
            } else if (this.formDisplayType === 'wizard') {
                baseSchema = defaultWizardSchema;
            }
            this.currentSchema = cloneDeep(baseSchema);
            await this.loadBuilder();  // rebuild it 
        },
        async saveSchema() {
            this.checkBuilderValid();
            // save the built form (form version) to the DB with new schema, etc.
            if (!this.isBuilderValid) {
                this.$toast.error('Builder is not valid');
                return;  // don't allow saving invalid schema!
            }
            try {
                const updateData = { raw_schema: cloneDeep(this.currentBuilderSchema) };  // ONLY change the schema here?  or other things about the form(version)?
                // TODO - don't allow updating existing / live versions!  Make new versions!
                const { data } = await suppliosApi.workflowFormVersion.update_admin_builder(this.formVersionId, updateData);
                // reset the local formVersion data from the response???
                console.log(data);
                //this.formVersion = Object.assign({}, data);
                this.$toast.success('Saved new schema!');
            } catch (err) {
                this.apiErrorHandler(err);
            }
        },
    }
}
</script>

<style>

</style>